import { gql } from 'apollo-boost'

export const LIST_BOARD_MESSAGE_APPEARANCES_QUERY = gql`
  query ListBoardMessageAppearancesForArrayHistory($id: String!, $cursor: String, $limit: Int) {
    listBoardMessageAppearancesV2(input: { boardId: $id, cursor: $cursor, limit: $limit }) {
      messageAppearances {
        id
        attribution
        created
        sentAt
        message {
          id
          text
          characters
        }
      }
      nextCursor
    }
  }
`

export const BOARD_DEVICES_QUERY = gql`
  query BoardDevicesForAcks($boardId: String!) {
    board(id: $boardId) {
      id
      devices {
        id
      }
    }
  }
`
